import React from "react";
import { Route, Routes, Navigate, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import { history } from "utils/history";
import { Auth } from "./utils";
import {
  NotFound,
  Home,
  Login,
  Callback,
  Forbidden,
  Users,
  User,
  Roles,
  Role,
  UserNew,
  RoleNew,
  LogOut,
  LoggedOut,
  AuthError,
  StandingParams,
  TraderParams,
  BidParam,
  TemplateSets,
  TemplateOffer,
  TemplateSet,
  TemplateSetNew,
  SubmittedOffer,
  SubmittedSet,
  SubmittedSets,
  JsonViewer,
  Offers,
  AckOffer,
  AlgoOffer,
  DraftOffer,
  AckSets,
  SolveList,
  SolveResult,
  AckSet,
  DeleteSuccess,
  AckSetOffer,
  Solve,
  AutoStatusHistory,
  BidAllocator,
  DispatchTimesHistory,
  SolveResultComposite
} from "./views";
import { AuthenticatedRoute } from "./components";
import { InternalRoutes } from "./utils";

const auth = new Auth();

const MainRoutes = props => {
  return (
    <HistoryRouter history={history}>
      <Routes>
        <Route path="/" element={<Navigate to={InternalRoutes.Home} replace />} />
        <Route
          path={InternalRoutes.Home}
          element={<AuthenticatedRoute auth={auth} element={<Home />} />}
        />
        <Route
          path={InternalRoutes.Offers}
          element={<AuthenticatedRoute auth={auth} element={<Offers />} />}
        />
        <Route
          path={InternalRoutes.DraftOffer}
          element={<AuthenticatedRoute auth={auth} element={<DraftOffer />} />}
        />
        <Route
          path={InternalRoutes.AckOffer}
          element={<AuthenticatedRoute auth={auth} element={<AckOffer />} />}
        />
        <Route
          path={InternalRoutes.AlgoOffer}
          element={<AuthenticatedRoute auth={auth} element={<AlgoOffer />} />}
        />
        <Route
          path={InternalRoutes.TemplateSets}
          element={<AuthenticatedRoute auth={auth} element={<TemplateSets />} />}
        />
        <Route
          path={InternalRoutes.TemplateSetNew}
          element={<AuthenticatedRoute auth={auth} element={<TemplateSetNew />} />}
        />
        <Route
          path={InternalRoutes.TemplateSet}
          element={<AuthenticatedRoute auth={auth} element={<TemplateSet />} />}
        />
        <Route
          path={InternalRoutes.TemplateOffer}
          element={<AuthenticatedRoute auth={auth} element={<TemplateOffer />} />}
        />
        <Route
          path={InternalRoutes.AckSets}
          element={<AuthenticatedRoute auth={auth} element={<AckSets />} />}
        />
        <Route
          path={InternalRoutes.AckSet}
          element={<AuthenticatedRoute auth={auth} element={<AckSet />} />}
        />
        <Route
          path={InternalRoutes.AckSetOffer}
          element={<AuthenticatedRoute auth={auth} element={<AckSetOffer />} />}
        />
        <Route
          path={InternalRoutes.SolveList}
          element={<AuthenticatedRoute auth={auth} element={<SolveList />} />}
        />
        <Route
          path={InternalRoutes.SolveCompositeResult}
          element={<AuthenticatedRoute auth={auth} element={<SolveResultComposite />} />}
        />
        <Route
          path={InternalRoutes.Solve}
          element={<AuthenticatedRoute auth={auth} element={<Solve />} />}
        />
        <Route
          path={InternalRoutes.SolveResult}
          element={<AuthenticatedRoute auth={auth} element={<SolveResult />} />}
        />
        <Route
          path={InternalRoutes.SubmittedSets}
          element={<AuthenticatedRoute auth={auth} element={<SubmittedSets />} />}
        />
        <Route
          path={InternalRoutes.SubmittedSet}
          element={<AuthenticatedRoute auth={auth} element={<SubmittedSet />} />}
        />
        <Route
          path={InternalRoutes.SubmittedOffer}
          element={<AuthenticatedRoute auth={auth} element={<SubmittedOffer />} />}
        />
        <Route
          path={InternalRoutes.JsonViewer}
          element={<AuthenticatedRoute auth={auth} element={<JsonViewer />} />}
        />
        <Route
          path={InternalRoutes.StandingParams}
          element={<AuthenticatedRoute auth={auth} element={<StandingParams />} />}
        />
        <Route
          path={InternalRoutes.TraderParams}
          element={<AuthenticatedRoute auth={auth} element={<TraderParams />} />}
        />
        <Route
          path={InternalRoutes.BidParam}
          element={<AuthenticatedRoute auth={auth} element={<BidParam />} />}
        />
        <Route
          path={InternalRoutes.AutoStatusHistory}
          element={<AuthenticatedRoute auth={auth} element={<AutoStatusHistory />} />}
        />
        <Route
          path={InternalRoutes.DispatchTimesHistory}
          element={<AuthenticatedRoute auth={auth} element={<DispatchTimesHistory />} />}
        />
        <Route
          path={InternalRoutes.BidAllocator}
          element={<AuthenticatedRoute auth={auth} element={<BidAllocator />} />}
        />
        <Route
          path={InternalRoutes.Users}
          element={<AuthenticatedRoute auth={auth} element={<Users />} />}
        />
        <Route
          path={InternalRoutes.User}
          element={<AuthenticatedRoute auth={auth} element={<User />} />}
        />
        <Route
          path={InternalRoutes.UserNew}
          element={<AuthenticatedRoute auth={auth} element={<UserNew />} />}
        />
        <Route
          path={InternalRoutes.Roles}
          element={<AuthenticatedRoute auth={auth} element={<Roles />} />}
        />
        <Route
          path={InternalRoutes.Role}
          element={<AuthenticatedRoute auth={auth} element={<Role />} />}
        />
        <Route
          path={InternalRoutes.RoleNew}
          element={<AuthenticatedRoute auth={auth} element={<RoleNew />} />}
        />
        <Route
          path={InternalRoutes.DeleteSuccess}
          element={<AuthenticatedRoute auth={auth} element={<DeleteSuccess />} />}
        />
        <Route
          path="/auth/login/:pdClientType?"
          element={<Login auth={auth} />}
        />
        <Route
          path="/auth/logout"
          element={<LogOut auth={auth} />}
        />
        <Route path="/auth/loggedout" element={<LoggedOut />} />
        <Route
          path="/auth/callback"
          element={<Callback auth={auth} />}
        />
        <Route
          path="/auth/forbidden"
          element={<Forbidden auth={auth} />}
        />
        <Route
          path={InternalRoutes.AuthError}
          element={<AuthError />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HistoryRouter>
  );
};

export default MainRoutes;
